/** @format */

export interface HomrWireSpotImageAsset {
  altText: string;
  type: string;
  value: string;
}

export interface HomrWireSpotVisualAsset {
  [index: string]: HomrWireSpotImageAsset | number;
}

export interface HomrWireSpotCarouselSlide {
  logo?: string;
  title: string;
  visualAssets: HomrWireSpotVisualAsset[];
  wysiwyg?: string;
}

export interface HomrWireSpotCarouselContent {
  enhancedProductCard: HomrWireSpotCarouselSlide[];
}

export interface HomrWireSpotCarouselResponse {
  content: HomrWireSpotCarouselContent;
}
